import React, { useState } from "react";
import Grid from "@mui/material/Grid";
import Stack from "components/common/Stack";
import DashboardDataCard from "components/Dashboard/DashboardDataCard";
import { formatHelper } from "helper/format";
import Box from "components/common/Box";
import Text from "components/common/Text";
import { useHistory } from "react-router-dom";

const RMSDashboardStatsContainer = (props) => {
  const { portfolioStats, rmsCallStats, isRmsCallLoading, isPortfolioLoading } =
    props;

  const {
    totalAUM,
    totalStocks,
    portfolioAUM,
    portfolioStockQuantity,
    totalCash,
    suggestProduct,
  } = portfolioStats;

  const { RMScalls, downfallSaved, opportunityLost } = rmsCallStats;

  const [showCashCTA, setShowCashCTA] = useState(false);
  const history = useHistory();

  const handleRidirect = () => {
    const text = suggestProduct.toLowerCase();

    // 2. redirect logic
    if (text.includes("portfolio")) {
      history.push("/jarvis-portfolio/dashboard");
    } else if (text.toLowerCase().includes("one stock")) {
      history.push("/jarvis-onestock/dashboard");
    }
  };

  const handlerShowCash = () => {
    if (suggestProduct?.length > 0) {
      setShowCashCTA(!showCashCTA);
    }
  };

  return (
    <>
      <Grid container spacing={2}>
        {/* AUM */}
        <Grid item xs={12} sm={6} md={4}>
          <DashboardDataCard
            visibleIcon
            icon="/svgs/rupee_icon.svg"
            loading={isPortfolioLoading}
            value={formatHelper.currency(Math.abs(portfolioAUM || totalAUM))}
            label="AUM under monitor"
            color="#000000"
          />
        </Grid>

        {/* Stocks under monitor */}
        <Grid item xs={12} sm={6} md={4}>
          <DashboardDataCard
            visibleIcon
            icon="/svgs/monitor.svg"
            loading={isPortfolioLoading}
            value={portfolioStockQuantity || totalStocks}
            label="Stocks under monitor"
            color="#000000"
          />
        </Grid>

        {/* Total sell calls */}
        <Grid item xs={12} sm={6} md={4}>
          <DashboardDataCard
            visibleIcon
            icon="/svgs/graph.svg"
            loading={isPortfolioLoading}
            value={RMScalls}
            label="Total sell calls"
            color="#000000"
          />
        </Grid>

        {/* Avg Downfall Saved */}
        <Grid item xs={12} sm={6} md={4}>
          <DashboardDataCard
            visibleIcon
            icon="/svgs/down_trend.svg"
            loading={isRmsCallLoading}
            value={
              isNaN(downfallSaved)
                ? "-"
                : formatHelper.currency(Math.abs(downfallSaved))
            }
            label="Average downfall Saved"
            color="#45AC70"
          />
        </Grid>

        {/* Opportunity Lost */}
        <Grid item xs={12} sm={6} md={4}>
          <DashboardDataCard
            visibleIcon
            icon="/svgs/uptrend.svg"
            loading={isRmsCallLoading}
            value={
              isNaN(opportunityLost)
                ? "-"
                : formatHelper.currency(Math.abs(opportunityLost))
            }
            label="Opportunity Lost"
            color="#E0953D"
          />
        </Grid>

        {/* Cash Released (clickable) */}
        <Grid item xs={12} sm={6} md={4}>
          <div onClick={() => handlerShowCash()} style={{ cursor: "pointer" }}>
            <DashboardDataCard
              visibleIcon
              icon="/svgs/cash_icon.svg"
              loading={isPortfolioLoading}
              value={formatHelper.currency(Math.abs(totalCash || 0))}
              label="Cash Released"
              color="#3A6BFF"
              sx={{ cursor: "pointer" }}
            />
          </div>

          {/* CTA section (only visible when clicked) */}
          {showCashCTA && (
            <Box
              sx={{
                p: 1.5,
                background: "linear-gradient(90deg, #00D1FF, #406BFF)",
                borderBottomLeftRadius: "10px",
                borderBottomRightRadius: "10px",
              }}
            >
              <Stack
                direction="row"
                justifyContent="space-between"
                alignItems="center"
              >
                <Text color="#fff" sx={{ fontSize: "14px" }}>
                  ✨ {suggestProduct}
                </Text>
                <Text
                  color="#fff"
                  sx={{
                    textDecoration: "underline",
                    fontWeight: 600,
                    fontSize: 16,
                    cursor: "pointer",
                  }}
                  onClick={() => handleRidirect()}
                >
                  Invest Now
                </Text>
              </Stack>
            </Box>
          )}
        </Grid>
      </Grid>
    </>
  );
};

export default RMSDashboardStatsContainer;
